import { useEffect } from "react";
import { Navbar, Footer } from "../layouts";
import {
  BankvoleHero,
  BankvoleTrustBadges,
  BankvoleGoalsSection,
  BankvolePlansSection,
  BankvoleAutoDebitSection,
  BankvoleBillsSection,
  BankvoleReferralSection,
  BankvoleSecuritySection,
  BankvoleExpertiseSection,
  BankvoleCTABanner,
  BankvoleContact,
  Grid,
} from "../components";
import { Helmet } from "react-helmet-async";

const BankvolePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Bankvole by Checkoff Finance</title>

        <meta
          name="description"
          content="Bankvole helps you securely earn more and grow your money. Choose flexible plans from ₦50,000: Earn, Keep, Flex & Build. Licensed by CBN, NDPR compliant. Download now."
        />

        <meta
          name="keywords"
          content="Bankvole, savings app Nigeria, investment app Nigeria, Checkoff Finance, save money Nigeria, fixed deposit Nigeria, auto-debit savings, NDIC insured savings, CBN licensed fintech, Nigeria investment plans, high interest savings Nigeria, Bill Boost, Billboost"
        />

        <meta property="og:title" content="Bankvole by Checkoff Finance" />

        <meta
          property="og:description"
          content="Bankvole helps you grow your money, and achieve your short-term and long-term financial goals. Get Bankvole on iOS and Android. Licensed by CBN, trusted by 18,000+ users."
        />

        <meta property="og:type" content="website" />

        <meta property="og:url" content="https://checkoff.finance/bankvole" />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://checkoff.finance/bankvole" />
      </Helmet>
      <Navbar />
      <Grid />
      <BankvoleHero />
      <BankvoleTrustBadges />
      <BankvoleGoalsSection />
      <BankvolePlansSection />
      <BankvoleAutoDebitSection />
      <BankvoleBillsSection />
      <BankvoleReferralSection />
      <BankvoleSecuritySection />
      <BankvoleExpertiseSection />
      <BankvoleCTABanner />
      <BankvoleContact />
      <Footer />
    </>
  );
};

export default BankvolePage;
